import Paho from 'paho-mqtt';
// import 'paho-mqtt';
import BuildSettings from '../buildSettings';
import Analytics from 'APP_ROOT/services/analytics';

//implementation based on the Paho example from http://www.eclipse.org/paho/clients/js/
//documentation here http://www.eclipse.org/paho/files/jsdoc/index.html
export default class MqttWebSocketService {

    constructor(tripUuid, password, onTripUpdate, onMQTTConnectionChanged) {

        this.tripUuid = tripUuid;
        this.password = password;
        this.onTripUpdate = onTripUpdate;
        this.onMQTTConnectionChanged = onMQTTConnectionChanged;

        // Create a client instance
        var clientId = 'tripshare-user-' + Date.now() + '-' + parseInt(Math.random() * 1000);
        Analytics.event({
            category: Analytics.EventCategory.TripSharing,
            action: Analytics.EventAction.Connect,
        });
        // var port = BuildSettings.environment() === 'prod' ? 8083 : 1884;
        console.log(BuildSettings.tripShareMqttHost(), clientId);

        this.client = new Paho.Client(BuildSettings.tripShareMqttHost(), 8083, clientId);

        // set callback handlers
        this.client.onConnected = this.onConnected;
        this.client.onConnectionLost = this.onConnectionLost;
        this.client.onMessageArrived = this.onMessageArrived;

        this.retryTimeout = 2000;
        this.retryCount = 0;
        // connect the client
        this.connect();

        window.mqttWebSocketService = this;
    }

    connect = () => {

        console.log("Mqtt socket connecting... ", this.tripUuid);
        this.client.connect({
            userName: this.tripUuid,
            password: this.password,
            onSuccess: this.onConnect,
            onFailure: (e) => {
                console.error("Paho MQTT connect onFailure:", e);
                this.onMQTTConnectionChanged(false);
                // this.retryTimeout += Math.min(this.retryTimeout, 30000);
                // this.retryTimer++;
                // if (this.retryCount > 10) return;
                // setTimeout(() => {
                //     this.connect();
                // }, this.retryTimeout);
            },
            useSSL: true //all environments are now SSL
        });
    }

    disconnect() {

        if (this.client) this.client.disconnect();
        this.onMQTTConnectionChanged(false);
    }

    // called when the client connects
    onConnect = () => {

        // Once a connection has been made, make a subscription and send a message.
        console.log("Paho MQTT onConnect");
        var topic = "trip/" + this.tripUuid;
        console.log(topic);
        this.client.subscribe(topic);
        this.onMQTTConnectionChanged(true);
    }

    onConnected = (reconnected, uri) => {

        console.log('onconnected: ', reconnected, uri);
        this.onMQTTConnectionChanged(true);
    }

    // called when the client loses its connection
    onConnectionLost = (responseObject) => {

        if (responseObject.errorCode !== 0) {
            console.error("Paho MQTT onConnectionLost: \n", responseObject.errorMessage);
            this.onMQTTConnectionChanged(false);
            this.connect();
        }
    }

    // called when a message arrives
    onMessageArrived = (message) => {

        try {
            var payload = JSON.parse(message.payloadString);
            // console.log("Trip Sharing update recieved", payload.trip);
            //route update
            if (payload) this.onTripUpdate(payload.trip);
        } catch (e) {
            console.error(e, message);
        }
    }
}
